// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__jwD2w","outlined":"styles_outlined__ns-aO","dark":"styles_dark__J9y7A","light":"styles_light__dC4Fg"};